/* cg-fixes.js (Round 30, Oct 10 2026). Sitewide behavior fixes, loaded from snippets/card-description-clamp.liquid.
   1. Item sheet: choice groups (sides, temps, bread, "pick up to 2") show up front; only true add-ons stay folded.
   2. Dine-in only list (Oct 11 2026: emptied, every dish is orderable online; see note at HIDE).
   3. Drinks: the size / flavor Toast needs as a modifier is written from the variant the guest picked.
   4. "Complete your meal" upsell row in the side cart and on the cart page, like the delivery apps. */
(function () {
  'use strict';

  /* 1. sheet layout */
  function label(g) {
    var max = +g.dataset.max || 0, req = g.dataset.required === '1';
    var em = g.querySelector('.cgm-rule'); if (!em) return;
    if (req) em.textContent = max > 1 ? 'Required · pick up to ' + max : 'Required';
    else em.textContent = max > 1 ? 'Pick up to ' + max : 'Pick 1';
  }
  function fixSheet(root) {
    root.querySelectorAll('.cgm-extras:not(.cgm-notes)').forEach(function (det) {
      if (det.dataset.cgFixed) return; det.dataset.cgFixed = '1';
      var moved = 0;
      det.querySelectorAll('.cgm-group').forEach(function (g) {
        if ((+g.dataset.max || 0) > 0 || g.dataset.required === '1') { label(g); det.parentNode.insertBefore(g, det); moved++; }
      });
      var left = det.querySelectorAll('.cgm-group').length, n = det.querySelector('.cgm-extras__n');
      if (!left) det.hidden = true;
      else if (moved && n) n.textContent = left + (left > 1 ? ' groups' : ' group');
    });
  }

  /* 2. Oct 11 2026: Niko wants every dish orderable online, so the dine-in only list is empty.
     These 41 dishes were not on Toast's online menu; their Toast visibility for online / third-party ordering
     has to be on or Checkmate cannot place them:
     7475808796831 7475808272543 7475808829599 7475808043167 7475808632991 7475808108703 7475807649951 7475811156127
     7475810697375 7475810926751 10921276539039 7475814170783 7475814039711 7475812696223 7475812728991 7475812794527
     7475805847711 7475806339231 7577686114463 7480033640607 7475811778719 7475811647647 7475811549343 8241609277599
     7475811942559 7491752853663 7489584791711 7475806404767 7475807486111 7475807518879 7475806470303 7475815776415
     7475806503071 7475806535839 7475806601375 7475806699679 7475806732447 7475807420575 7475807060127 7475807551647 7475815121055 */
  var HIDE = [];
  var css = document.createElement('style');
  css.textContent = (HIDE.length ? HIDE.map(function (id) { return '[data-product-id="' + id + '"] [data-cgm-add]'; }).join(',') + '{display:none!important}' : '') +
    '.cg-instore{display:inline-block;font-size:1.2rem;font-weight:700;color:#6b6d72;background:#f2efe9;border-radius:999px;padding:4px 10px;margin-top:6px}' +
    '.cg-ups{margin:14px 0 6px}.cg-ups h4{margin:0 0 8px;font-size:1.5rem;font-weight:800;color:#1a1a1a}' +
    '.cg-ups__row{display:flex;gap:10px;overflow-x:auto;padding-bottom:6px;scrollbar-width:none;-webkit-overflow-scrolling:touch}.cg-ups__row::-webkit-scrollbar{display:none}' +
    '.cg-ups__card{flex:0 0 128px;background:#fff;border:1px solid #ece7de;border-radius:14px;overflow:hidden;display:flex;flex-direction:column}' +
    '.cg-ups__card img{width:100%;height:92px;object-fit:cover;background:#f4f1ec}' +
    '.cg-ups__b{padding:8px;display:flex;flex-direction:column;gap:4px;flex:1}' +
    '.cg-ups__n{font-size:1.25rem;font-weight:700;line-height:1.25;color:#1a1a1a;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:3.1rem}' +
    '.cg-ups__f{display:flex;align-items:center;justify-content:space-between;margin-top:auto}.cg-ups__p{font-size:1.25rem;color:#48494b}' +
    '.cg-ups__add{width:30px;height:30px;border-radius:50%;border:0;background:#d94300;color:#fff;font-size:1.9rem;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center}' +
    '.cg-ups__add[aria-busy=true]{opacity:.5}';
  document.head.appendChild(css);
  function instoreCards() {
    HIDE.forEach(function (id) {
      document.querySelectorAll('[data-product-id="' + id + '"]').forEach(function (c) {
        if (c.querySelector('.cg-instore')) return;
        var t = c.querySelector('.cgc-card__title, .cgc-card__body') || c;
        var s = document.createElement('span'); s.className = 'cg-instore'; s.textContent = 'Dine-in only';
        t.appendChild(s);
      });
    });
    var pj = document.querySelector('script[data-cgm-product]');
    if (pj && HIDE.indexOf(String(pj.getAttribute('data-cgm-product'))) > -1) {
      document.querySelectorAll('.cgm-pdp, #cg-bar, #cg-ot [data-add]').forEach(function (e) { e.style.display = 'none'; });
      var ot = document.getElementById('cg-ot');
      if (ot && !ot.querySelector('.cg-instore')) { var n = document.createElement('p'); n.className = 'cg-instore'; n.textContent = 'Dine-in only. Order it at the restaurant, or call (562) 907-7017.'; ot.insertBefore(n, ot.firstChild); }
    }
  }

  /* 3. drink modifiers from the variant (variant id -> properties Toast needs)
     Oct 11 2026, like for like with Toast online: drinks are a Size variant (priced like Toast's Size modifier)
     plus the flavor as a modifier group (Soft Drinks Choice, Juice Choice, Ice Tea Flavor) picked in the sheet. */
  var VPROPS = {
    '42786862301343': { 'Size': 'Small' }, '62890874405023': { 'Size': 'Large' },
    '42455933354143': { 'Size': 'Large 20oz' }, '62890874437791': { 'Size': 'Extra Large 32oz' },
    '42786850111647': { 'Size': 'Medium 20oz' }, '62890874372255': { 'Size': 'Xtra Large 32oz' },
    '42455933517983': { 'Size': 'Large' }, '62890874470559': { 'Size': 'Xtra Large' },
    '42786863546527': { 'Milkshake Options': 'Chocolate' }, '42786863579295': { 'Milkshake Options': 'Strawberry' }, '42786863612063': { 'Milkshake Options': 'Vanilla' }, '42786863644831': { 'Milkshake Options': 'Oreo' }
  };
  function addProps(item) {
    var bv = item && item.properties && item.properties._bv;
    if (bv) delete item.properties._bv;
    var p = item && (VPROPS[String(item.id)] || (bv && VPROPS[String(bv)])); if (!p) return;
    item.properties = item.properties || {};
    Object.keys(p).forEach(function (k) { if (!item.properties[k]) item.properties[k] = p[k]; });
  }
  /* 3b. paid add-ons: each priced modifier the guest picks is charged as its own line (product "Menu Add-ons",
         variant "<Toast group>: <Toast option>") linked to the dish by _link, so checkout total = Toast total */
  var ADD = null, ADDP = null;
  function loadAdd() {
    if (ADD) return Promise.resolve(ADD);
    if (ADDP) return ADDP;
    try { var c = JSON.parse(sessionStorage.getItem('cg_addons_v1') || 'null'); if (c && c.m) { ADD = c; return Promise.resolve(ADD); } } catch (e) {}
    ADDP = of0('/products/menu-add-ons.js').then(function (r) { return r.json(); }).then(function (pr) {
      var m = {}; pr.variants.forEach(function (v) { m[v.title] = v.id; });
      ADD = { pid: pr.id, m: m }; try { sessionStorage.setItem('cg_addons_v1', JSON.stringify(ADD)); } catch (e) {}
      return ADD;
    }).catch(function () { ADD = { pid: 0, m: {} }; return ADD; });
    return ADDP;
  }
  /* R48 (Oct 16 2026): no more separate "Menu Add-ons" lines. Checkmate rejected every order that had one
     ("Menu Add-ons was not found in the POS"). Paid extras are now charged on the dish line itself through
     the dish's "Add-ons" variant (assets/cg-menu.js), so this only adds the Toast size properties. */
  var ADDON_LINES = false;
  function withAddons(items) {
    var out = [];
    items.forEach(function (it) {
      out.push(it); addProps(it);
      if (!ADDON_LINES) return;
      var pr = it.properties || {}, adds = [];
      Object.keys(pr).forEach(function (k) {
        if (k.charAt(0) === '_' || k === 'Special Instructions') return;
        var vid = ADD.m[k.replace(/ \(\d+\)$/, '') + ': ' + pr[k]]; if (vid) adds.push(vid);
      });
      if (!adds.length) return;
      var L = Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      it.properties = Object.assign({}, pr, { _link: L });
      adds.forEach(function (vid) { out.push({ id: vid, quantity: it.quantity || 1, properties: { _link: L, _addon: '1' } }); });
    });
    return out;
  }
  var of0 = window.fetch;
  var syncing = false;
  function syncAddons() {
    if (syncing) return Promise.resolve(false);
    syncing = true;
    return loadAdd().then(function () { return of0('/cart.js').then(function (r) { return r.json(); }); }).then(function (cart) {
      var parentQty = {}, jobs = [];
      cart.items.forEach(function (i) { var L = i.properties && i.properties._link; if (L && i.product_id !== ADD.pid) parentQty[L] = (parentQty[L] || 0) + i.quantity; });
      cart.items.forEach(function (i) {
        var L = i.properties && i.properties._link; if (!L || i.product_id !== ADD.pid) return;
        var want = parentQty[L] || 0; if (want !== i.quantity) jobs.push({ id: i.key, quantity: want });
      });
      var chain = Promise.resolve();
      jobs.forEach(function (j) { chain = chain.then(function () { return of0('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(j) }); }); });
      return chain.then(function () { syncing = false; return jobs.length > 0; });
    }).catch(function () { syncing = false; return false; });
  }
  function refreshAfterSync(changed) {
    if (!changed) return;
    if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.renderContents === 'function') of0('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) { d.renderContents({ sections: s }); }).catch(function () {});
  }
  if (window.fetch && !window.fetch.__cgDrinks) {
    var of = window.fetch;
    var w = function (input, init) {
      var self = this, args = arguments;
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string' && init.body.charAt(0) === '{') {
          var b = JSON.parse(init.body);
          return loadAdd().then(function () {
            if (b.items) b.items = withAddons(b.items); else if (b.id) { var x = withAddons([b]); b = x.length > 1 ? { items: x } : x[0]; }
            return of.call(self, input, Object.assign({}, init, { body: JSON.stringify(b) }));
          });
        }
        if (/\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) {
          return of.apply(self, args).then(function (res) { setTimeout(function () { syncAddons().then(refreshAfterSync); }, 50); return res; });
        }
      } catch (e) {}
      return of.apply(self, args);
    };
    Object.keys(of).forEach(function (k) { w[k] = of[k]; }); w.__cgDrinks = true; window.fetch = w;
  }
  /* cart line for an add-on: no own qty or remove controls, it follows the dish */
  var acss = document.createElement('style');
  acss.textContent = '.cart-item:has(a[href*="/products/menu-add-ons"]) .cart-item__quantity,.cart-item:has(a[href*="/products/menu-add-ons"]) cart-remove-button,.cart-item:has(a[href*="/products/menu-add-ons"]) .cart-item__media{visibility:hidden}' +
    '.cart-item:has(a[href*="/products/menu-add-ons"]) .cart-item__name{font-size:1.3rem;font-weight:600;color:#55565a}';
  document.head.appendChild(acss);
  if (/^\/cart\/?$/.test(location.pathname)) syncAddons().then(refreshAfterSync);

  /* 4. Complete your meal */
  var UPS = ['strawberry-lemonade-beverages', 'cgm-019-onion-rings-2022-08-05', 'cgm-018-fries-2022-08-05', 'cgm-020-sweet-potatoes-2022-08-05', 'chocolate-cake', 'ny-cheesecake', 'carrot-cake', 'cgm-171-heavenly-tiramisu-2022-08-05'];
  var upsData = null;
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function loadUps() {
    if (upsData) return Promise.resolve(upsData);
    try { var c = JSON.parse(sessionStorage.getItem('cg_ups_v1') || 'null'); if (c) { upsData = c; return Promise.resolve(c); } } catch (e) {}
    return Promise.all(UPS.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (list) {
        upsData = list.filter(function (p) { return p && p.available; }).map(function (p) { return { id: p.id, v: p.variants[0].id, t: p.title, p: p.variants[0].price, img: p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=260' : '' }; });
        try { sessionStorage.setItem('cg_ups_v1', JSON.stringify(upsData)); } catch (e) {}
        return upsData;
      });
  }
  var upsBusy = 0;
  function renderUps(host, before, onPage) {
    if (!host || host.querySelector('.cg-ups') || Date.now() - upsBusy < 2500) return;
    upsBusy = Date.now();
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.item_count) return;
      var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
      return loadUps().then(function (list) {
        var items = list.filter(function (x) { return !inCart[x.id]; }).slice(0, 6);
        if (!items.length || host.querySelector('.cg-ups')) return;
        var box = document.createElement('div'); box.className = 'cg-ups';
        box.innerHTML = '<h4>Complete your meal</h4><div class="cg-ups__row">' + items.map(function (x) {
          return '<div class="cg-ups__card">' + (x.img ? '<img src="' + x.img + '" alt="" loading="lazy">' : '') + '<div class="cg-ups__b"><span class="cg-ups__n">' + x.t.replace(/</g, '&lt;').replace(/\s*\((Side)\)/, '') + '</span><div class="cg-ups__f"><span class="cg-ups__p">' + money(x.p) + '</span><button type="button" class="cg-ups__add" data-v="' + x.v + '" aria-label="Add ' + x.t.replace(/"/g, '') + '">+</button></div></div></div>';
        }).join('') + '</div>';
        if (before && before.parentNode) before.parentNode.insertBefore(box, before); else host.appendChild(box);
        box.addEventListener('click', function (e) {
          var b = e.target.closest('.cg-ups__add'); if (!b) return;
          b.setAttribute('aria-busy', 'true');
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.v, quantity: 1 }] }) })
            .then(function (r) { if (!r.ok) throw 0; if (onPage) location.reload(); else { var bb = b.closest('.cg-ups__card'); if (bb) bb.remove(); } })
            .catch(function () { b.removeAttribute('aria-busy'); });
        });
      });
    }).catch(function () {});
  }
  function ups() {
    var d = document.querySelector('cart-drawer');
    if (d && d.classList.contains('active')) { var list = d.querySelector('#CartDrawer-CartItems') || d.querySelector('.drawer__inner'); renderUps(list, null, false); }
    if (/^\/cart\/?$/.test(location.pathname)) { var f = document.getElementById('main-cart-footer'); if (f) renderUps(f.parentNode, f, true); }
  }

  /* 6. mobile: bottom actions always reachable, checkout never hangs (Oct 11 2026)
     - Shopify's preview bar (and the phone's home bar) covered "Add to order", "Review order" and the side cart
       button. Lift them clear of the preview bar and pad for the iPhone safe area.
     - "Complete your meal" sits at the end of the scrolling item list, so it no longer squeezes the items and the
       Check out button on small screens.
     - If Check out is tapped and the page has not moved on after 6 seconds, go straight to /checkout. */
  var mcss = document.createElement('style');
  mcss.textContent =
    '.cgc-modal__foot{padding-bottom:max(12px,env(safe-area-inset-bottom))!important}' +
    '.cgc-bar{padding-bottom:env(safe-area-inset-bottom)}' +
    '@supports (height:100dvh){.cgc-modal{height:100dvh!important}}' +
    /* preview only: pad (never move) bottom UI so Shopify's preview bar can't cover the buttons */
    'html.cg-pbar .cgc-modal__foot{padding-bottom:calc(12px + var(--cg-pbar))!important}' +
    'html.cg-pbar .cgc-bar{padding-bottom:var(--cg-pbar)}' +
    'html.cg-pbar cart-drawer .drawer__footer{padding-bottom:calc(14px + var(--cg-pbar))!important}' +
    /* spin-to-win tab: never on top of ordering. Hidden while a dish sheet, the When sheet, the side cart or the
       order bar is up, on the menu and cart pages, and whenever the cart has items. */
    '#cgsw.is-teaser{z-index:900!important}' +
    'html.cg-ordering #cgsw.is-teaser{display:none!important}' +
    'cart-drawer .cg-ups{margin:16px 0 4px}' +
    '@media screen and (max-width:749px){cart-drawer .cg-ups__card{flex-basis:112px}cart-drawer .cg-ups__card img{height:74px}}';
  document.head.appendChild(mcss);
  function pbar() {
    var on = !!document.getElementById('PBarNextFrame');
    document.documentElement.classList.toggle('cg-pbar', on);
    document.documentElement.style.setProperty('--cg-pbar', on ? (innerWidth < 750 ? '64px' : '44px') : '0px');
  }
  pbar(); setTimeout(pbar, 1500); setTimeout(pbar, 4000); window.addEventListener('resize', pbar);
  function ordering() {
    var bub = document.querySelector('#cart-icon-bubble .cart-count-bubble span, #cart-icon-bubble .cart-count-bubble');
    var n = bub ? parseInt(bub.textContent, 10) || 0 : 0;
    var busy = !!document.querySelector('.cgc-modal.is-open, cart-drawer.active, .cgc-bar.is-visible, .cgc-drawer.is-open') ||
      /^\/(pages\/food-menu-new|cart|checkout)/.test(location.pathname) || n > 0;
    document.documentElement.classList.toggle('cg-ordering', busy);
    /* the full spin popup must never open on top of an open sheet or the side cart */
    var sw = document.getElementById('cgsw');
    if (sw && sw.classList.contains('is-open') && document.querySelector('.cgc-modal.is-open, cart-drawer.active')) {
      var x = sw.querySelector('[data-cgsw-close]'); if (x) x.click();
    }
  }
  ordering();

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"]');
    if (!b) return;
    setTimeout(function () {
      if (e.defaultPrevented) return;
      var left = false; window.addEventListener('pagehide', function () { left = true; }, { once: true });
      setTimeout(function () { if (!left && document.visibilityState === 'visible') location.href = '/checkout'; }, 6000);
    }, 0);
  });

  var t = null;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var x = muts[i].target;
      if (x.nodeType === 1 && x.closest && x.closest('.cgm-sheet, .cgc-modal')) fixSheet(x.closest('.cgm-sheet, .cgc-modal'));
    }
    ordering(); clearTimeout(t); t = setTimeout(function () { instoreCards(); ups(); ordering(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  function boot() { instoreCards(); ups(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
